import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../features/auth/authSlice';
import { organizationsApi } from '../features/organizations/organizationsApi';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    [organizationsApi.reducerPath]: organizationsApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(organizationsApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
